@if (language() === 'ar') {
  <popsy-icon-baseeta-badge-ar class="icon" [ngClass]="size" aria-hidden="true" />
}
@if (language() !== 'ar') {
  <popsy-icon-baseeta-badge-en class="icon" [ngClass]="size" aria-hidden="true" />
}
